import { render, staticRenderFns } from "./Tabletransient.vue?vue&type=template&id=29c37634"
import script from "./Tabletransient.vue?vue&type=script&lang=js"
export * from "./Tabletransient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports